export const SET_PRODUCTS = () => 'SET_PRODUCTS';
export const SET_VIEW = () => 'SET_VIEW';
export const UPDATE_PRODUCT = () => 'UPDATE_PRODUCT';
